import { useStore } from 'vuex'
import { onMounted, computed } from 'vue'
import BasketAside from 'components/BasketAside/BasketAside.vue'
import BasketCard from 'components/BasketCard/BasketCard'
import CheckoutStepOne from 'components/CheckoutStepOne/CheckoutStepOne.vue'
import CheckoutStepTwo from 'components/CheckoutStepTwo/CheckoutStepTwo.vue'
import CheckoutStepThree from 'components/CheckoutStepThree/CheckoutStepThree.vue'

export default {
    name: 'CheckoutContent',
    components: {
        BasketAside,
        BasketCard,
        CheckoutStepOne,
        CheckoutStepTwo,
        CheckoutStepThree
    },
    props: {},
    setup() {
        const store = useStore()

        onMounted(() => {
            store.dispatch('basket/fetchBasket')
        })

        const checkoutSteps = computed(() => store.state.checkout.checkoutSteps)

        const activeStep = computed(() =>
            checkoutSteps.value.find((i) => i.active === true)
        )

        const determineCheckoutStepContent = function () {
            switch (activeStep.value.stepNumber) {
                case 1:
                    return 'CheckoutStepOne'
                case 2:
                    return 'CheckoutStepTwo'
                case 3:
                    return 'CheckoutStepThree'
                case 4:
                    // here user gets directed to receipt page
                    return
                default:
                    console.warn('No active checkout step defined')
                    break
            }
        }

        const handleStepClick = function (clickedStepNumber) {
            const validClickedStepNumber =
                clickedStepNumber < activeStep.value.stepNumber
                    ? clickedStepNumber
                    : activeStep.value.stepNumber
            store.commit('checkout/update_checkout_step', {
                nextStepNumber: validClickedStepNumber
            })
        }

        return {
            activeStep,
            checkoutSteps,
            determineCheckoutStepContent,
            handleStepClick
        }
    }
}
